
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[name]",
      function () {
        return require("private-next-pages/category/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[name]"])
      });
    }
  